import { createRouter, createWebHistory } from 'vue-router';

import { getServerMode, init as initSupabase, session } from '../supabase';
import AdminPanel from '../views/AdminPanel.vue';
import Bootstrap from '../views/BootstrapView.vue';
import Home from '../views/HomeMain.vue';
import Analysis from '../views/MainAnalysis.vue';
import SuperAdmin from '../views/SuperAdmin.vue';
// import Main from '../views/Main.vue';
import Login from '../views/UserLogin.vue';

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false },
    props: route => ({ redirect: route.query.redirect }),
  },
  // {
  //   path: '/main',
  //   name: 'Main',
  //   component: Main,
  // },
  {
    path: '/home',
    name: 'Home',
    component: Home,
  },
  {
    path: '/analysis',
    name: 'Analysis',
    component: Analysis,
  },
  {
    path: '/bootstrap',
    name: 'bootstrap',
    component: Bootstrap,
    meta: { requiresAuth: false },
    beforeEnter: async (/* to, from */) => {
      try {
        return (await getServerMode()) === 'bootstrapping' || '/';
      }
      catch (error) {
        console.error('Error getting server mode:', error);
        return '/';
      }
    },
  },
  {
    path: '/superadmin',
    name: 'superadmin',
    component: SuperAdmin,
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminPanel,
  },
];

let wasPopState = false;
window.addEventListener('popstate', () => {
  wasPopState = true;
});

await initSupabase();

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from) => {
  if (wasPopState) {
    // Prevent leaving analysis via popstate events.
    wasPopState = false;
    if (from.name === 'Analysis') {
      return false;
    }
  }
  if (to.meta.requiresAuth ?? true) {
    if (!session.value) {
      return {
        name: 'Login',
        query: {
          redirect: to.fullPath,
        },
      };
    }
  }

  if (to.name === 'Login') return true;

  try {
    const mode = await getServerMode();
    if (mode === 'bootstrapping' && to.name !== 'bootstrap') {
      return { name: 'bootstrap' };
    }
    if (mode === 'setup' && to.name !== 'superadmin') {
      return { name: 'superadmin' };
    }
  }
  catch (error) {
    console.error('Error getting server mode:', error);
    return '/';
  }

  return true;
});

export default router;
